import { render, staticRenderFns } from "./PowersSelect.vue?vue&type=template&id=dfb22010&scoped=true&"
import script from "./PowersSelect.vue?vue&type=script&lang=js&"
export * from "./PowersSelect.vue?vue&type=script&lang=js&"
import style0 from "./PowersSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PowersSelect.vue?vue&type=style&index=1&id=dfb22010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb22010",
  null
  
)

export default component.exports